// generated from 94 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const attributedAdFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("attributed_ad_filter"),
  comparison_key: z.enum(["1", "2", "10"]),
  display_name: z.string(),
  // undefined: 3 (3.19%), defined 91 (96.81%)
  raw_value: z.string().optional(),
  value: z.string(),
  varies_by_app_group: z.literal(true),
});
